import axiosInstance from "../utils/axios";
export const getWhatsappItems = async (type, cancelToken) => {
  return await axiosInstance().get(`/getWhatsappItems?type=${type}`, {
    cancelToken
  });
};
export const updateWhatsappItems = async (values, cancelToken) => {
  return await axiosInstance().post(`/updateWhatsappItems`, values, {
    cancelToken
  });
}

export const getActiveNurturing = async (type, cancelToken) => {
  return await axiosInstance().get(`/getActiveNurturing?type=${type}`, {
    cancelToken
  });
};

export const stopNurturing = async (id, cancelToken) => {
  return await axiosInstance().post(`/stopNurturing`, {id}, {
    cancelToken
  });
}
export const sendWhatsapp = async (values, cancelToken) => {
  return await axiosInstance().post(`/sendWhatsapp`, values, {
    cancelToken
  });
}

export const getWhatsappNuturingAuditTrial = async (values, cancelToken) => {
  return await axiosInstance().post(`/getWhatsappNuturingAuditTrial`, values, { cancelToken: cancelToken });
};

export const getWhatsappNuturingAuditFilters = async (values, cancelToken) => {
  return await axiosInstance().post(`/getWhatsappNuturingAuditFilters`, values, {
    cancelToken: cancelToken
  });
};